import React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 76 76"
        fill="currentColor"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 42.2658,42.6939L 42.2658,39.7306L 53.6919,23.4539L 53.6919,23.3139L 43.298,23.3139L 43.298,18.7605L 60.7042,18.7605L 60.7042,21.9407L 49.5272,38L 49.5272,38.1405L 60.8831,38.1405L 60.8831,42.6939L 42.2658,42.6939 Z M 27.6278,50.6304L 27.6278,48.713L 35.0212,38.181L 35.0212,38.0904L 28.2958,38.0904L 28.2958,35.1441L 39.5586,35.1441L 39.5586,37.2018L 32.3264,47.5931L 32.3264,47.6841L 39.6744,47.6841L 39.6744,50.6304L 27.6278,50.6304 Z M 15.5589,56.9736L 15.5589,55.5791L 20.9359,47.9195L 20.9359,47.8536L 16.0447,47.8536L 16.0447,45.7108L 24.2358,45.7108L 24.2358,47.2074L 18.976,54.7647L 18.976,54.8308L 24.32,54.8308L 24.32,56.9736L 15.5589,56.9736 Z "
        />
    </svg>,
    "Sleep",
);
